import React, { PropsWithChildren } from 'react';
import ElationChartButton from './ElationChartButton';
import ThemedComponent from '../../../theme/ThemedComponent';
import { PatientService } from '../../../../core/services/patient.service';
import { Patient } from '@models';

type ElationChartButtonWrapperProps = PropsWithChildren<{
  displayPatientElationLink: boolean;
  patientElationLink: string | undefined;
}>;

export function ElationChartButtonWrapper({
  displayPatientElationLink,
  patientElationLink,
}: ElationChartButtonWrapperProps): React.JSX.Element {
  return (
    <ThemedComponent>
      <ElationChartButton
        displayPatientElationLink={displayPatientElationLink}
        patientElationLink={patientElationLink}
      />
    </ThemedComponent>
  );
}

export default ElationChartButtonWrapper;
